// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"b8b8cf63abb3bbe458b7","453":"a771db2708745d556f68"}[chunkId] + ".js";
};